import { useEffect, useState } from 'react'
import { useGetIdentity, useResourceContext } from 'react-admin'
import { useFormContext, useFormState, useWatch } from 'react-hook-form'

import { formDraftKey, readFormDraft, removeFormDraft, writeFormDraft } from '../../utils/formDrafts'

export const useDraftKey = () => {
  const resource = useResourceContext()
  const { identity } = useGetIdentity()
  return identity?.id ? formDraftKey(identity.id, resource) : null
}

const omitPickedFiles = (_, value) => (value?.rawFile instanceof File ? undefined : value)

export const FormDraft = () => {
  const { control, reset } = useFormContext()
  const draftKey = useDraftKey()
  const snapshot = JSON.stringify(useWatch({ control }), omitPickedFiles)
  const { isDirty } = useFormState({ control })
  const [isMounted, setIsMounted] = useState(false)
  const [restoredKey, setRestoredKey] = useState(null)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  useEffect(() => {
    if (!isMounted || !draftKey || restoredKey === draftKey) return
    const draft = readFormDraft(draftKey)
    if (draft) reset(draft, { keepDefaultValues: true })
    setRestoredKey(draftKey)
  }, [draftKey, isMounted, reset, restoredKey])

  useEffect(() => {
    if (!draftKey || restoredKey !== draftKey) return
    if (isDirty) writeFormDraft(draftKey, snapshot)
    else removeFormDraft(draftKey)
  }, [draftKey, isDirty, restoredKey, snapshot])

  return null
}
